import { clone } from '@/common/js/just.js'

/**
 * @description: 打开修改计划定向弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onPagesModify(rowIndex) {
  // 点击单行时设置check状态
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, pagesCheck: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.pagesCheck)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  // 保存当前需要更改的行，如果是全选更改，那么保存第一个
  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])

  this.modal.showGlobalPagesModify = true
}

/**
 * @description: 更换落地页确认
 * @return {*}
 */
export function onPagesModifyConfirm(creativeForm) {
  if (creativeForm.pageInfo) {
    this.tableData = this.tableData.map((row) => {
      if (row.pagesCheck) {
        // const newRow = { ...row, creative: { ...creativeForm } }
        const newRow = clone(row)
        newRow.creative.pageInfo = { ...creativeForm.pageInfo }
        return newRow
      }
      return row
    })
  }

  this.onModifyModalCancel()
}

/**
 * @description: 打开修改计划落地页弹窗
 * @param {*} rowIndex // 单条修改时的行索引
 * @return {*}
 */
export function onPagesV3Modify(rowIndex) {
  if (!Object.is(Number(rowIndex), NaN)) {
    this.tableData = this.tableData.map((row, index) => {
      return { ...row, pagesV3Check: index === rowIndex }
    })
  } else {
    if (!this.tableData.some((row) => row.pagesV3Check)) {
      return this.$Message.warning('请选择修改行')
    }
  }

  this.currentModifyTableRow = clone(this.tableData[rowIndex || 0])

  this.modal.showGlobalPagesV3Modify = true
}

/**
 * @description: 更换落地页确认
 * @return {*}
 */
export function onPagesV3ModifyConfirm(page) {
  if (page) {
    this.tableData = this.tableData.map((row) => {
      if (row.pagesV3Check) {
        const newRow = clone(row)
        newRow.creative.pageInfo = page
        return newRow
      }
      return row
    })
  }
  this.onModifyModalCancel()
}
